// eslint-disable-next-line no-undef
export const BASE_BACKEND_URL = GLOBAL_CONFIG.REACT_APP_APIM_URL;
// eslint-disable-next-line no-undef
export const ENVIRONMENT = GLOBAL_CONFIG.REACT_APP_ENVIRONMENT;

//export const PUNCH_OUT_URL = `http://localhost:7071/api/punchout`;

export const PUNCH_OUT_URL = `${BASE_BACKEND_URL}/ibuy-${ENVIRONMENT}-punchout/punchout`;

export const GET_PUNCH_OUT_SUPPLIER_LIST = `${PUNCH_OUT_URL}/supplier-list`;

export const INITIATE_PUNCH_OUT_SESSION = `${PUNCH_OUT_URL}/sessionCreation/`;

export const CANCEL_PUNCH_OUT_SESSION = `${PUNCH_OUT_URL}/sessionCancel/`;
